import { Grid, Typography, Rating, Button, Pagination, Box } from "@mui/material";
import { FC } from "react";

import categoria_prueba from '../../../assets/image/categoria_prueba.png';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';

interface ProductListV3Props {
    products: any
    presentation: string
    handleSelectProduct: (idproduct: number, quantity?: number) => Promise<void>
    showMoreProduct: (product: any) => void
}

export const ProductListV3: FC<ProductListV3Props> = (props) => {
    const { products, presentation, handleSelectProduct, showMoreProduct } = props

    return (
        <Grid container sx={{ width: '100%', display: 'flex', flexWrap: 'wrap', alignItems: 'center', alignContent: 'center', justifyContent: 'space-around', height: '100%' }}>

            {/* Vista en lista */}
            {presentation === 'list' && products.length > 0 && products.map((product) => (
                <Grid key={product.id} style={{ width: '350px', margin: '2px', display: 'flex', flexDirection: 'row', padding: '5px', cursor: 'pointer' }}>
                    <div style={{ width: '30%', margin: '5px' }}>
                        <FavoriteBorderIcon fontSize='small' style={{ marginBottom: 'none' }} />
                        <div style={{ width: '100%', display: 'flex', alignItems: 'center', alignContent: 'center', justifyContent: 'center' }}>
                            <img style={{ width: '100%' }} src={categoria_prueba} alt="" />
                        </div>
                    </div>
                    <div style={{ width: '70%' }}>
                        <Typography fontSize={'bigger'} fontWeight={'bold'}>{product.name_product}</Typography>
                        <div>
                            <Rating
                                name="star-rating"
                                value={product.rating}
                                precision={0.5}
                                // onChange={handleRatingChange
                                style={{ color: '#91CBF9' }}
                                readOnly
                            />
                        </div>
                        {product.discount > 0 && <Typography fontSize={'small'} style={{ textDecoration: 'line-through', color: '#9c9c9c' }}>$ {product.price}</Typography>}
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Typography fontSize={'bigger'} fontWeight={'bold'}>$ {product.discount > 0 ? product.price : product.price}</Typography>
                            {product.discount > 0 && <Typography fontSize={'11px'} style={{ backgroundColor: 'red', color: 'white', borderRadius: '0px 0px 0px 10px', padding: '2px', marginLeft: '5px' }}>-{product.discount}%</Typography>}
                        </div>
                        <div style={{ flexDirection: 'column' }}>
                            <Typography fontSize={'small'} fontWeight={'bold'}>Envío Gratis*</Typography>
                            {product.discount > 0 && <Typography fontSize={'9px'} fontWeight={'bold'}>+10% CON CUPÓN LLANT10</Typography>}
                        </div>
                        <div style={{ width: '100%' }}>
                            <Button sx={{ border: '2px solid #D0D0D0', borderRadius: '20px', fontSize: '7px', color: '#707070', height: '25px', margin: '5px' }} onClick={() => showMoreProduct(product)}>Ver más</Button>
                            <Button
                                sx={{
                                    borderRadius: '20px',
                                    fontSize: '7px',
                                    backgroundColor: '#91CBF9',
                                    color: '#fff',
                                    height: '25px',
                                    "&:hover": { backgroundColor: "#91CBF9" }
                                }}
                                onClick={() => handleSelectProduct(product.idproduct)}
                            >Añadir al carrito</Button>
                        </div>
                    </div>
                </Grid>
            ))}

            {/* Vista en grid */}
            {/* {presentation === 'grid' && products.length > 0 && products.map((product) => (
                <div key={product.id} style={{ width: '300px', margin: '2px', display: 'flex', flexDirection: 'row', padding: '5px', cursor: 'pointer' }}>
                    <div style={{ width: '40%', margin: '5px' }}>
                        <FavoriteBorderIcon fontSize='small' style={{ marginBottom: 'none' }} />
                        <img style={{ width: '100%' }} src={categoria_prueba} alt="" />
                    </div>
                    <div style={{ width: '60%' }}>
                        <Typography fontSize={'bigger'} fontWeight={'bold'}>{product.name_product}</Typography>
                        <div>
                            <Rating
                                name="star-rating"
                                value={product.rating}
                                precision={0.5}
                                // onChange={handleRatingChange}
                                style={{ color: '#91CBF9' }}
                                readOnly
                            />
                        </div>
                        <Typography fontSize={'small'} style={{ textDecoration: 'line-through', color: '#9c9c9c' }}>S/ 959.00</Typography>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Typography fontSize={'bigger'} fontWeight={'bold'}>S/ 629.00</Typography>
                            <Typography fontSize={'11px'} style={{ backgroundColor: 'red', color: 'white', borderRadius: '0px 0px 0px 10px', padding: '2px', marginLeft: '5px' }}>-34%</Typography>
                        </div>
                        <div>
                            <Typography fontSize={'small'} fontWeight={'bold'}>Envío Gratis*</Typography>
                            <Typography fontSize={'9px'} fontWeight={'bold'}>+10% CON CUPÓN LLANT10</Typography>
                        </div>
                        <div style={{ width: '100%' }}>
                            <Button sx={{ border: '2px solid #D0D0D0', borderRadius: '20px', fontSize: '7px', color: '#707070', height: '25px', margin: '5px' }} onClick={() => setShowModalProduct(true)}>Ver más</Button>
                            <Button sx={{ borderRadius: '20px', fontSize: '7px', backgroundColor: '#91CBF9', color: '#fff', height: '25px' }}>Añadir al carrito</Button>
                        </div>
                    </div>
                </div>
            ))} */}

            {
                (presentation === 'list' || presentation === 'grid') && products.length === 0 &&
                <Grid item container xs={12} sx={{ height: '100%' }}>
                    <Box sx={{
                        backgroundColor: 'rgba(224, 224, 224, 0.5)',
                        padding: '30px',
                        borderRadius: '10px',
                        height: '100%',
                        justifyContent: 'center',
                        alignItems: 'center',
                        display: 'flex',
                        width: '100%',
                        marginRight: '15px',
                        minHeight: '350px'
                    }} >
                        NO SE ENCONTRARON PRODUCTOS
                    </Box>
                </Grid>
            }
        </Grid>
    )
}